import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";
const style = () => {
    const { colorTextMedium, space6, space8 } = theme();
    return StyleSheet.create({
        description: {
            color: colorTextMedium,
            padding: 0,
        },
        link: {
            textDecorationLine: "underline",
        },
        modal: {
            paddingHorizontal: space6,
        },
        modalGap: {
            marginTop: space8,
        },
    });
};
export { style };
